<template>
	<main>
		<section class="vx-row m-0 justify-center w-full bg-sahabat">
			<div class="vx-col w-full md:w-5/6">
				<nav class="flex items-start mb-4">
					<div class="hidden md:block">
						<img src="/assets/images/sahabat-zx/logo-sahabat.png" class="w-3/4" alt="" />
					</div>
					<ul class="flex items-center mt-12">
						<li class="mx-2 px-0 md:mx-0 md:px-2 lg:px-4">
							<router-link to="/home" class="text-warning">
								Home
							</router-link>
						</li>
						<li class="px-2 lg:px-4">
							<router-link to="/about" class="text-warning">
								Tentang ZX
							</router-link>
						</li>
						<li class="px-2 lg:px-4">
							<router-link to="/sahabat-zx" class="text-warning">
								Sahabat ZX
							</router-link>
						</li>
						<li class="px-2 lg:px-4">
							<router-link to="/promo" class="text-warning">
								Promo
							</router-link>
						</li>
						<li class="px-2 lg:px-4">
							<router-link to="/zxcare" class="text-warning">
								ZX Care
							</router-link>
						</li>
					</ul>
				</nav>
			</div>
			<vs-divider style="background: transparent;"></vs-divider>
			<vs-divider style="background: transparent;"></vs-divider>
			<vs-divider style="background: transparent;"></vs-divider>
			<vs-divider style="background: transparent;"></vs-divider>
		</section>
		<router-view></router-view>
		<the-light-footer />
	</main>
</template>
<script>
import TheLightFooter from '@/layouts/components/TheLightFooter.vue'

export default {
  components: {
    TheLightFooter
  }
}
</script>
<style>
	.bg-sahabat {
		background: url('/assets/images/sahabat-zx/bg.png');
		background-repeat: no-repeat;
		background-size: cover;
	}
</style>
